"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderItems = exports.OrderItemThumbnail = exports.OrderItemTextButton = exports.OrderItemName = exports.OrderItemInfo = exports.OrderItemDisclaimer = exports.OrderItemButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _Img = _interopRequireDefault(require("../Img"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _grid = require("@rebass/grid");
var _link = _interopRequireDefault(require("next/link"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AsyncButton = _interopRequireDefault(require("../AsyncButton"));
const _excluded = ["children", "linkProps", "renderAccommodationLink"],
  _excluded2 = ["faded"],
  _excluded3 = ["onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const OrderItem = (_ref, ref) => {
  let {
      children,
      linkProps,
      renderAccommodationLink
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return __jsx(OrderItemContainer, (0, _extends2.default)({
    ref: ref,
    flexDirection: ['column', null, null, 'row'],
    justifyContent: ['space-between']
  }, props), linkProps && !renderAccommodationLink && __jsx(_link.default, (0, _extends2.default)({
    passHref: true
  }, linkProps, {
    legacyBehavior: true
  }), __jsx(LinkOverlay, null)), children);
};
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(OrderItem);
const LinkOverlay = _styledComponents.default.a.withConfig({
  displayName: "OrderItem__LinkOverlay",
  componentId: "llvmhu-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;"]);
const OrderItemContainer = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "OrderItem__OrderItemContainer",
  componentId: "llvmhu-1"
})(["position:relative;margin-right:1.2rem;padding:0;background:rgb(255,255,255);border-radius:0.8rem;transition:all 0.15s ease-in-out;:hover{box-shadow:rgba(59,118,160,0.2) 0px 16px 30px 0px,rgba(59,118,160,0.2) 0px 24px 80px 0px;}box-shadow:rgba(59,118,160,0.1) 0px 16px 24px 0px,rgba(59,118,160,0.1) 0px 24px 80px 0px;@media screen and (min-width:", "){border:1px solid rgb(247,248,249);width:100%;padding-right:", ";margin-bottom:2.9rem;:last-of-type{margin-bottom:0;}margin-right:0;align-items:center;}"], ({
  theme
}) => theme.mediaQueries.m, ({
  theme
}) => theme.spacing['70_XLarge']);
const OrderItemThumbnail = _ref2 => {
  let {
      faded = false
    } = _ref2,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return __jsx(ThumbnailContainer, {
    faded: faded
  }, __jsx(_Img.default, (0, _extends2.default)({}, props, {
    layout: "fill"
  })));
};
exports.OrderItemThumbnail = OrderItemThumbnail;
const ThumbnailContainer = _styledComponents.default.div.withConfig({
  displayName: "OrderItem__ThumbnailContainer",
  componentId: "llvmhu-2"
})(["opacity:", ";position:relative;width:100%;height:19.1rem;overflow:hidden;border-top-left-radius:0.8rem;border-top-right-radius:0.8rem;flex-shrink:0;img{object-fit:cover;}@media screen and (min-width:", ") and (max-width:", "){display:none;}@media screen and (min-width:", "){border-bottom-left-radius:0.8rem;border-top-right-radius:0;margin-right:", ";width:20.8rem;flex-shrink:0;}"], ({
  faded
}) => faded ? 0.4 : 1, ({
  theme
}) => theme.mediaQueries.xs, ({
  theme
}) => theme.mediaQueries.xl, ({
  theme
}) => theme.mediaQueries.l, ({
  theme
}) => theme.spacing['50_Semi']);
const OrderItemInfo = exports.OrderItemInfo = (0, _styledComponents.default)(_grid.Flex).attrs({
  flexDirection: 'column'
}).withConfig({
  displayName: "OrderItem__OrderItemInfo",
  componentId: "llvmhu-3"
})(["padding:", ";width:100%;@media screen and (min-width:", "){padding:0;padding-right:1.6rem;margin-top:0;width:unset;}"], ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.mediaQueries.m);
const OrderItemDisclaimer = exports.OrderItemDisclaimer = (0, _styledComponents.default)(_Body.default).attrs({
  variant: 'small'
}).withConfig({
  displayName: "OrderItem__OrderItemDisclaimer",
  componentId: "llvmhu-4"
})(["font-weight:500;margin-bottom:", ";color:", ";"], ({
  theme
}) => theme.spacing['20_Tiny'], ({
  theme
}) => theme.colors.primary['50']);
const OrderItemName = exports.OrderItemName = (0, _styledComponents.default)(_Body.default).attrs({
  variant: 'huge'
}).withConfig({
  displayName: "OrderItem__OrderItemName",
  componentId: "llvmhu-5"
})(["color:", ";font-weight:600;margin-bottom:1.2rem;"], ({
  theme
}) => theme.colors.neutral['70']);
const OrderItemTextButton = props => __jsx(StyledTextButton, (0, _extends2.default)({}, props, {
  onClick: e => {
    e.preventDefault();
    props.onClick?.(e);
  }
}));
exports.OrderItemTextButton = OrderItemTextButton;
const OrderItemButton = _ref3 => {
  let {
      onClick
    } = _ref3,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return __jsx(StyledButton, (0, _extends2.default)({}, props, {
    onClick: e => {
      e.preventDefault();
      onClick?.(e);
    }
  }));
};
exports.OrderItemButton = OrderItemButton;
const buttonStyles = (0, _styledComponents.css)(["justify-self:flex-end;margin:", " 0;margin-left:", ";align-self:flex-start;z-index:1;@media screen and (min-width:", "){align-self:unset;margin:0;}"], ({
  theme
}) => theme.spacing['50_Semi'], ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.mediaQueries.s);
const StyledButton = (0, _styledComponents.default)(_AsyncButton.default).withConfig({
  displayName: "OrderItem__StyledButton",
  componentId: "llvmhu-6"
})(["", ";"], buttonStyles);
const StyledTextButton = (0, _styledComponents.default)(_TextButton.default).withConfig({
  displayName: "OrderItem__StyledTextButton",
  componentId: "llvmhu-7"
})(["", ""], buttonStyles);
const OrderItems = exports.OrderItems = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "OrderItem__OrderItems",
  componentId: "llvmhu-8"
})(["margin-bottom:", ";@media screen and (max-width:", "){margin:0;padding-bottom:", ";flex-direction:row;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{display:none;}width:calc(100% + var(--wrapperPadding) * 2);margin-left:calc(var(--wrapperPadding) * -1);> div:first-of-type{margin-left:var(--wrapperPadding);}}@media screen and (min-width:", "){> * + *{margin-top:1.6rem;}}flex-direction:column;"], ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.spacing['60_Large'], ({
  theme
}) => theme.mediaQueries.s);